<template>
  <div class="ui-side-menu-list">
    <div class="ui-side-menu-list-head">
      <slot name="head"></slot>
    </div>
    <TransitionGroup tag="ul" class="ui-side-menu-list-ul" name="slide-list">
      <slot name="list"></slot>
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

$closer-height: 2rem;
.ui-side-menu-list {
  padding: 16px 20px;
  .ui-side-menu-list-head {
    display: flex;
    justify-content: space-between;
    h3, .title {
      color: $jps-gray-800;
      font-size: 1.25rem;
      font-weight: bold;
      line-height: 150%;
    }
    button, a {
      color: $jps-gray-800;
      @include no-decorative-button();
      font-size: 0.75rem;
      font-weight: bold;
    }
    margin-bottom: 14px;
  }
  .ui-side-menu-list-ul {
    display: flex;
    flex-direction: column;
    gap: 14px;
    li {
      width: 100%;
      list-style: none;
      button, a {
        width: 100%;
        height: 41px;
        @include no-decorative-button();
        border-radius: 6px;
        font-size: 0.875rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 10px;
        color: $jps-gray-800;
        padding: 0.5rem 0.75rem;
        text-align: left;
        margin-bottom: 0.5rem;
        transition: all $transition-timing;
        border: 1px solid $jps-gray-50;
        .jps-icon {
          margin-left: 0.25rem;
        }
        &.jps-active,
        &:hover {
          box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
          background-color: $white;
        }
      }
    }
    @include is-mobile() {
      gap: 8px;
    }
  }
}
</style>
